'use client'

import Link from 'next/link'

type AuthActionsProps = {
	mode?: 'both' | 'login-only' | 'register-only'
}

export function AuthActions({ mode = 'both' }: AuthActionsProps) {
	return (
		<section className="mt-6">
			<div className="flex items-start justify-around px-2">
				{(mode === 'both' || mode === 'register-only') && (
					<Link href="/register" className="group flex flex-col items-start gap-2">
						<span className="flex items-center gap-2">
							<span className="text-[18px] leading-none font-medium text-(--brand-primary)">+</span>
							<span className="text-[13px] font-semibold tracking-[0.18em] text-(--brand-secondary) uppercase">
								Registro
							</span>
						</span>
						<span className="block h-0.75 w-26 bg-(--brand-primary)" />
					</Link>
				)}

				{(mode === 'both' || mode === 'login-only') && (
					<Link href="/login" className="group flex flex-col items-start gap-2">
						<span className="flex items-center gap-2">
							<ArrowRightIcon />
							<span className="text-[13px] font-semibold tracking-[0.18em] text-(--brand-secondary) uppercase">
								Ingresar
							</span>
						</span>
						<span className="block h-0.75 w-26 bg-(--brand-primary)" />
					</Link>
				)}
			</div>

			<p className="text-muted-foreground pt-8 text-center text-[9px] font-extrabold tracking-[0.16em] uppercase">
				Términos y condiciones
			</p>
		</section>
	)
}

function ArrowRightIcon() {
	return (
		<svg
			width="14"
			height="10"
			viewBox="0 0 14 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="shrink-0"
			aria-hidden="true"
		>
			<path d="M1 5H11" stroke="var(--brand-primary)" strokeWidth="1.8" strokeLinecap="square" />
			<path
				d="M8 1L12 5L8 9"
				stroke="var(--brand-primary)"
				strokeWidth="1.8"
				strokeLinecap="square"
				strokeLinejoin="miter"
			/>
		</svg>
	)
}
